import React from 'react';
import { Input, InputNumber, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  year: number;
  deptFrom: string;
  deptTo: string;
  empFrom: string;
  empTo: string;
  loading: boolean;
  onYearChange: (v: number) => void;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onEmpFromChange: (v: string) => void;
  onEmpToChange: (v: string) => void;
  onQuery: () => void;
}

const QueryParams: React.FC<QueryParamsProps> = ({
  year, deptFrom, deptTo, empFrom, empTo, loading,
  onYearChange, onDeptFromChange, onDeptToChange,
  onEmpFromChange, onEmpToChange, onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Department range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門代號[從]</span>
          <Input
            value={deptFrom}
            onChange={(e) => onDeptFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 80 }}
            maxLength={4}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={deptTo}
            onChange={(e) => onDeptToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 80 }}
            maxLength={4}
          />
        </div>
      </div>

      {/* Row 2: Employee range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>人員代號[從]</span>
          <Input
            value={empFrom}
            onChange={(e) => onEmpFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 120 }}
            maxLength={8}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={empTo}
            onChange={(e) => onEmpToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 120 }}
            maxLength={8}
          />
        </div>
      </div>

      {/* Row 3: Year selector */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>年度</span>
          <InputNumber
            value={year}
            onChange={(v) => onYearChange(v ?? new Date().getFullYear())}
            min={1990}
            max={2099}
            style={{ width: 100 }}
          />
        </div>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
